import request from '../../utils/request'

export function fetchList (data) {
  return request.post('/business/category/page', data, {
    trim: true
  })
}

export function create (data) {
  return request.post('/business/category/create', data, {
    trim: true
  })
}

export function updateStatus (data) {
  return request.post('/business/category/updateStatus', data, {
    trim: true
  })
}

export function updateById (data) {
  return request.post('/business/category/updateById', data, {
    trim: true
  })
}

export function getById (id) {
  return request.get(`/business/category/${id}`)
}

export function deleteById (id) {
  return request.get(`/business/category/delete/${id}`)
}
